import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { RequireAuth } from './Auth/RequireAuth';
import { AuthInitializer } from '@/Components/auth/AuthInitializer';
import NotFound from './NotFound';
import Layout from './Layout';

const router = createBrowserRouter([
  {
    path: '/',
    // AuthInitializer : hydrate la session v2 (refresh) et pose isAuthReady —
    // sans lui, RequireAuth attendrait indéfiniment (spinner infini)
    element: (
      <AuthInitializer>
        <Outlet />
      </AuthInitializer>
    ),
    children: [
      {
        path: '/login',
        lazy: () => import("./Auth/Login").then(m => ({ Component: m.default })),
      },
      {
        // Changement de mot de passe forcé (première connexion) : AuthInitializer
        // redirige ici — page partagée avec l'admin (après succès, retour « / »
        // qui renvoie sur /dashboard). Sans cette route, les nouveaux users
        // Upsell tombaient sur un 404.
        path: '/change-password-required',
        lazy: () => import("../admin/Auth/ChangePasswordRequired").then(m => ({ Component: m.default })),
      },
      {
        path: '/offer/:token',
        lazy: () => import("./OfferLanding").then(m => ({ Component: m.default })),
      },
      {
        // Prévisualisation landing via JWT signé (admin → domaine vendeur)
        path: '/offer-preview/:previewToken',
        lazy: () => import("./OfferLanding").then(m => ({ Component: m.default })),
      },
      {
        path: '/pre-upsell/:token',
        lazy: () => import("./PreUpsellCallback").then(m => ({ Component: m.default })),
      },
      {
        path: '/',
        element: <RequireAuth />,
        children: [
          {
            path: '/',
            element: <Layout />,
            children: [
              {
                index: true,
                element: <Navigate to="/dashboard" replace />,
              },
              {
                path: 'dashboard',
                lazy: () => import("./Dashboard").then(m => ({ Component: m.default })),
              },
              {
                path: 'leads/:contractId',
                lazy: () => import("./LeadDetail").then(m => ({ Component: m.default })),
              },
              {
                // Page Performance (vue équipe) — gatée upsell.dashboard
                path: 'analytics',
                lazy: () => import("./Analytics").then(m => ({ Component: m.default })),
              },
              // Nouveautés (fil d'annonces produit) : fil et page d'une nouveauté
              {
                path: 'nouveautes',
                lazy: () => import("./NewsReader").then(m => ({ Component: m.NewsFeedRoute })),
              },
              {
                path: 'nouveautes/:slug',
                lazy: () => import("./NewsReader").then(m => ({ Component: m.NewsDetailRoute })),
              },
              // La config des garanties reste dans l'admin
            ],
          },
        ]
      }
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  }
]);

export default router;
